import { Autocomplete, AutocompleteProps, TextField, TextFieldProps as TextFieldPropsType } from '@mui/material';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { languages } from '~/common/constants';

export interface LanguageAutocompleteProps extends Omit<
  AutocompleteProps<string, false, true, false>,
  'multiple' | 'disableClearable' | 'options' | 'renderInput' | 'renderTags' | 'getOptionLabel'
> {
  TextFieldProps?: Partial<TextFieldPropsType>;
}

export const LanguageAutocomplete = forwardRef<any, LanguageAutocompleteProps>(function CountryAutocomplete(
  { TextFieldProps, ...props },
  ref,
) {
  const { t } = useTranslation(undefined, { keyPrefix: 'language' });

  const getOptionLabel = (option: string) => {
    return t(option);
  };

  return (
    <Autocomplete
      {...props}
      ref={ref}
      disableClearable
      options={languages}
      getOptionLabel={getOptionLabel}
      renderInput={(params) => <TextField {...params} {...TextFieldProps} />}
    />
  );
});
